module.exports = __webpack_public_path__ + "img/050b_Solarpark.557ccad6.jpg";